export const MENU_SCREEN = Symbol('menu-screen');
export const INSTRUCTIONS_SCREEN = Symbol('instructions-screen');
export const PLAY_SCREEN = Symbol('play-screen');
export const PRIVACY_SCREEN = Symbol('privacy-screen');
export const CONTACT_SCREEN = Symbol('contact-screen');